export default `
  <div class="wb-doc-page">
    <div class="doc-text doc-pt16">盈寶證券社區是一個獲取、分享及傳播資訊的平臺，為向所有使用者提供更優質的服務，為維護社區的健康發展以及保障用戶合法權益，盈寶證券社區根據現行法律法規制定本規定。</div>

    <div class="doc-main-title">一、言論規則</div>

    <div class="doc-text doc-font-bold">1、禁止發佈違反法律法規和相關政策的內容。包括但不限於以下內容：</div>

    <div class="doc-text">1）反對憲法所規定的基本原則；</div>
    <div class="doc-text">2）危害國家安全，洩露國家秘密，顛覆國家政權，破壞國家統一，主權和領土完整；</div>
    <div class="doc-text">3）損害國家榮譽和利益；</div>
    <div class="doc-text">4）煽動民族仇恨、民族歧視，破壞民族團結，或者侵害民族風俗、習慣；</div>
    <div class="doc-text">5）歪曲、醜化、褻瀆、否定英雄烈士事蹟和精神，以侮辱、誹謗或者其他方式侵害英雄烈士的姓名、肖像、名譽、榮譽；</div>
    <div class="doc-text">6）宣揚恐怖主義、極端主義或煽動實施恐怖活動、極端主義活動；</div>
    <div class="doc-text">7）破壞國家宗教政策，宣揚邪教和封建迷信；</div>
    <div class="doc-text">8）散佈謠言。擾亂經濟秩序和社會秩序；</div>
    <div class="doc-text">9）散佈淫穢、色情、賭博、暴力、兇殺、毒品、恐怖或教唆犯罪；</div>
    <div class="doc-text">10）侮辱或誹謗他人，侵害他人名譽、隱私和其他合法權益；</div>
    <div class="doc-text">11）以營利、獲利為目的，違規發佈第三方理財產品、投資專案等廣告；</div>
    <div class="doc-text doc-pb28">12）法律、行政法規禁止的其他內容。</div>


    <div class="doc-text doc-font-bold">2、禁止發佈違反證券和基金法律法規的資訊以及非法證券投資諮詢活動資訊，包括但不限於以下內容：</div>

    <div class="doc-text">1）故意編造並散播影響證券、期貨等交易或其他擾亂金融秩序的虛假資訊；</div>
    <div class="doc-text">2）向用戶直接推薦股票代碼，提供股票直接買入賣出建議等；</div>
    <div class="doc-text">3）發佈“非法薦股”等非法證券投資諮詢活動資訊；</div>
    <div class="doc-text">4）變相誘導用戶到本社區以外的平臺管道（如微信，QQ等），向用戶提供各種股票教程，推薦證券產品等；</div>
    <div class="doc-text">5）通過文章或評論，誘導用戶到其他平臺開通股票、期貨等投資交易帳號；</div>
    <div class="doc-text">6）發佈誇大不實的相關文章，向使用者提供交易決策，並收取相關收益分成或費用；</div>
    <div class="doc-text">7）假冒相關合法證券機構，發佈以行銷為目的，提供非法證券投資諮詢業務行為；</div>
    <div class="doc-text doc-pb28">8）根據法律法規、監管規定等認定的其他形式的非法證券投資諮詢活動。</div>

    <div class="doc-text doc-font-bold">3、社區禁止的其他惡意違規行為及不良資訊內容：</div>

    <div class="doc-text">1）冒充他人或機構、國家機關、上市企業或盈寶證券官方人員，通過頭像及用戶名等暗示自己與他人或機構相等同或有關聯；</div>
    <div class="doc-text">2）註冊的ID名稱、頭像或簡介涉及政治性、侮辱性的；</div>
    <div class="doc-text">3）對社區其他用戶進行蓄意人身攻擊、謾駡、發佈低俗不文明的言論行為；</div>
    <div class="doc-text">4）通過註冊水軍，以人工或機器人方式發佈虛假內容、誤導使用者、炒作某類題材概念或個股、或干擾社區正常運作的行為；</div>
    <div class="doc-text">5）惡意洩露他人隱私，或者其他侵犯他人合法權益的行為；</div>
    <div class="doc-text">6）違規發佈/誘導使用者添加聯繫方式、下載協力廠商工具、加群、分享協力廠商連結等；</div>
    <div class="doc-text">7）留下任何聯繫方式、網址以及廣告、QQ群、微信號、公眾號、微博號等資訊；</div>
    <div class="doc-text">8）發佈各種推銷、廣告資訊或其他任何形式的勸誘資料；</div>
    <div class="doc-text">9）通過不同方式發佈或邀請使用者參加任何非盈寶證券官方組織的第三方舉辦的線上或線下活動；</div>
    <div class="doc-text">10）使用誇張標題，發佈與內容和標題嚴重不符的文章；</div>
    <div class="doc-text">11）其他影響社區正常運營的行為。</div>

    <div class="doc-main-title">二、社區違規處理</div>

    <div class="doc-text">1、根據使用者發佈的違法違規資訊行為的次數、影響程度以及其他相關因素，盈寶證券社區將視情況決定採取限制展示、刪除違規內容、帳號禁言、關閉帳號以及其他可行的處罰措施；</div>
    <div class="doc-text">2、盈寶證券社區在法律允許的最大範圍內保留對本規則和相關罰則的解釋權；</div>
    <div class="doc-text">3、盈寶證券社區可根據法制法規、社區建設和社區管理經驗的豐富，出於維護盈寶證券社區氛圍和發展的目的，不斷完善本規則。</div>

    <div class="doc-main-title">三、免責聲明及相關事項</div>

    <div class="doc-text">1、任何社區使用者所發佈的內容均系使用者個人行為, 並不反映任何本社區之意見, 盈寶證券及本社區不為其承擔任何法律責任；</div>
    <div class="doc-text">2、本社區只提供交流、討論場所，社區使用者發表的內容及言論僅代表其個人觀點，不代表本社區立場，對於社區使用者發表的內容及言論的真實性引發的全部責任，由社區用戶自行承擔，盈寶證券及本社區不承擔任何責任；</div>
    <div class="doc-text">3、本社區有權轉載或引用用戶通過本社區發表的文章作品；</div>
    <div class="doc-text doc-pb28">4、本社區有權在必要時修改規則條款，本社區規則條款一旦發生變動，將會在重要頁面上提示修改內容。如果不同意所改動的內容，使用者可以主動取消獲得的本社區資訊服務。如果使用者繼續享用本社區資訊服務，則視為接受規則條款的變動。本社區保留隨時修改或中斷服務而不需通知使用者的權利。本社區行使修改或中斷服務的權利，不需對用戶或第三方負責。</div>

    <div class="doc-text">用戶在本社區發表言論，等同於已閱讀並接受以上規則。</div>
  </div>
`
